import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Alert } from 'react-bootstrap';

const PaymentCompleteModel = ({ onClick, error, errNo, message, ...props }) => (
  <Modal {...props}>
    <Modal.Body>
      {error && (
        <Alert bsStyle="danger">
          <h4>There was an error during payment processing</h4>
          <p>{message}</p>
          <p>
            <Button onClick={onClick}>Okay</Button>
          </p>
        </Alert>
      )}
      {!error && (
        <div>
          <Alert bsStyle="success">
            <h4>Please wait...</h4>
            <p className="success-redirect-msg">
              You are being redirected to <a href={'https://payprco.com'}>PayPRco.com</a> to finish
              your payment process.
            </p>
          </Alert>

          <Modal.Footer>
            <Button onClick={onClick}>Close</Button>
          </Modal.Footer>
        </div>
      )}
    </Modal.Body>
  </Modal>
);

PaymentCompleteModel.propTypes = {
  onClick: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errNo: PropTypes.number,
  message: PropTypes.string,
};

PaymentCompleteModel.defaultProps = {
  error: false,
  errNo: 0,
  message: '',
};

export default PaymentCompleteModel;



// WEBPACK FOOTER //
// ./src/components/PaymentCompleteModal.js